import React from 'react';
import BarChart from './Charts/BarChart';
import LineChart from './Charts/LineChart';
import DonutChart from './Charts/DonutChart';
import PMKisanTrendChart from './Charts/PMKisanTrendChart';
import PMKisanYearlyChart from './Charts/PMKisanYearlyChart';
import EmptyState from '../../empty-state';

const PerformanceChart = ({ data, isHindi, darkMode }) => {
  const chartType = data['chart-type'];

  if (!data) {
    return <EmptyState height="260px" width="160px" />;
  }

  // Special handling for PM-KISAN
  const isPMKisan = data?.isPMKisanCheck && data?.toggle;

  if (isPMKisan && data?.key === 'trend-line') {
    return <PMKisanTrendChart data={data} isHindi={isHindi} darkMode={darkMode} />;
  }

  if (isPMKisan && data?.key === 'yearly') {
    return (
      <PMKisanYearlyChart
        data={data}
        selectedYear={data.selectedYear}
        isHindi={isHindi}
        darkMode={darkMode}
      />
    );
  }

  switch (chartType) {
    case 'bar-chart':
      return <BarChart data={data} isHindi={isHindi} darkMode={darkMode} />;

    case 'line-chart':
      return <LineChart data={data} darkMode={darkMode} />;

    case 'donut-chart':
      return <DonutChart data={data} darkMode={darkMode} />;

    default:
      return <BarChart data={data} isHindi={isHindi} darkMode={darkMode} />;
  }
};

export default PerformanceChart;
